module.exports = __webpack_public_path__ + "img/be-well-logo.5b72817b.svg";